// Module
var code = `<form name="\$ctrl.interestBoardForm">
  <h2 class="section-header">Interest rate board: {{\$ctrl.board.rateType | prettyEnum}}</h2>

  <div class="form-section ">
    <form-section-field field-title="'Default interest rate'">
      <glue-container append-percentage="true">
        <input
          required
          type="number"
          min="0"
          max="1000"
          step="0.00001"
          ng-model="\$ctrl.board.defaultRate">
      </glue-container>
    </form-section-field>
  </div>

  <table class="table board-cells">

    <!-- Header -->
    <thead>
    <tr>
      <th>#</th>
      <th>Min balance (inclusive)</th>
      <th>Max balance (exclusive)</th>
      <th>Min term (inclusive)</th>
      <th>Max term (exclusive)</th>
      <th>Interest rate</th>
      <th></th>
    </tr>
    </thead>

    <!-- Body -->
    <tbody>
    <tr ng-repeat="cell in \$ctrl.board.cells">
      <td>
        {{ \$index + 1 }}
      </td>
      <td>
        <cash ng-required="true"
          ng-model="cell.minBalance"></cash>
      </td>
      <td>
        <cash ng-model="cell.maxBalance"></cash>
      </td>
      <td>
        <glue-container append="'days'">
          <input
            required
            type="number"
            min="0"
            max="100000"
            step="1"
            ng-model="cell.minTerm">
        </glue-container>
      </td>
      <td>
        <glue-container append="'days'">
          <input
            type="number"
            min="0"
            max="100000"
            step="1"
            ng-model="cell.maxTerm">
        </glue-container>
      </td>
      <td>
        <glue-container append-percentage="true">
          <input
            required
            type="number"
            min="0"
            max="1000"
            step="0.00001"
            ng-model="cell.rate">
        </glue-container>
      </td>
      <td>
        <button
          class="btn btn-danger pull-right"
          ng-click="\$ctrl.remove(\$index)">
          Remove
        </button>
      </td>
    </tr>
    </tbody>

    <!-- Footer -->
    <tfoot>
    <tr>
      <td colspan="7">
        <button
          class="btn btn-success pull-right"
          type="button"
          ng-click="\$ctrl.create()">
          Add new
        </button>
      </td>
    </tr>
    </tfoot>

  </table>

</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/casa/interest-board/interest-board.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;